<template>
    <button
        :type="type"
        class="text-white text-md px-4 py-2 bg-green-500 border border-transparent rounded-md shadow-sm hover:bg-green-600 focus:border-green-500 focus:ring-green-500"
    >
        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'submit',
            },
        },
    };
</script>
